export default __webpack_public_path__ + "static/media/connect.2a430a63.svg";